module.exports = __webpack_public_path__ + "static/img/jurassic_warn.b4060ec1.png";